import { render, staticRenderFns } from "./ModalInformacao.vue?vue&type=template&id=2e4cd3a6"
import script from "./ModalInformacao.vue?vue&type=script&lang=js"
export * from "./ModalInformacao.vue?vue&type=script&lang=js"
import style0 from "./ModalInformacao.vue?vue&type=style&index=0&id=2e4cd3a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports